import { MegaraxUri, VisitView } from "../uri";
import { dateParam, LegacyRedirect, redirect, uuidParam } from "./redirect";

const polishVisitRedirects = (legacyView: string, view: VisitView): LegacyRedirect[] => [
  redirect(`/crm/pos/handlowcy/:userId/wizyty/${legacyView}/:date/wizyta/:uuid`, ({ userId, date, uuid }) => {
    const visitId = uuidParam(uuid);
    const parsedDate = dateParam(date);

    if (!visitId) return undefined;

    return parsedDate
      ? MegaraxUri("megarax://crm/salesperson-visits/id/{id}/{view}/{date}/visits/id/{visitId}", {
          id: userId,
          view,
          date: parsedDate,
          visitId,
        })
      : MegaraxUri("megarax://crm/visits/id/{id}", { id: visitId });
  }),
  redirect(`/crm/pos/handlowcy/:userId/wizyty/${legacyView}/:date/*`, ({ userId, date }) => {
    const parsedDate = dateParam(date);
    return parsedDate
      ? MegaraxUri("megarax://crm/salesperson-visits/id/{id}/{view}/{date}", { id: userId, view, date: parsedDate })
      : undefined;
  }),
  redirect(`/crm/pos/handlowcy/:userId/wizyty/${legacyView}/*`, ({ userId }) =>
    MegaraxUri("megarax://crm/salesperson-visits/id/{id}/{view}", { id: userId, view }),
  ),
];

const englishVisitRedirects = (view: VisitView): LegacyRedirect[] => [
  redirect(`/crm/pos/salespeople/:userId/visits/${view}/:date/*`, ({ userId, date }) => {
    const parsedDate = dateParam(date);
    return parsedDate
      ? MegaraxUri("megarax://crm/salesperson-visits/id/{id}/{view}/{date}", { id: userId, view, date: parsedDate })
      : undefined;
  }),
  redirect(`/crm/pos/salespeople/:userId/visits/${view}/*`, ({ userId }) =>
    MegaraxUri("megarax://crm/salesperson-visits/id/{id}/{view}", { id: userId, view }),
  ),
];

export const crmVisitRedirects: LegacyRedirect[] = [
  ...polishVisitRedirects("tydzien", "week"),
  ...polishVisitRedirects("dzien", "day"),
  ...englishVisitRedirects("week"),
  ...englishVisitRedirects("day"),

  redirect("/crm/pos/moje_wizyty", () => MegaraxUri("megarax://crm/my-visits")),
  redirect("/crm/pos/my-visits", () => MegaraxUri("megarax://crm/my-visits")),

  redirect("/crm/pos/handlowcy/:userId/wizyty/*", ({ userId }) =>
    MegaraxUri("megarax://crm/salesperson-visits/id/{id}", { id: userId }),
  ),
  redirect("/crm/pos/salespeople/:userId/visits/*", ({ userId }) =>
    MegaraxUri("megarax://crm/salesperson-visits/id/{id}", { id: userId }),
  ),
  redirect("/crm/pos/handlowcy/:userId", ({ userId }) => MegaraxUri("megarax://crm/salespeople/id/{id}", { id: userId })),
  redirect("/crm/pos/salespeople/:userId", ({ userId }) =>
    MegaraxUri("megarax://crm/salespeople/id/{id}", { id: userId }),
  ),
  redirect("/crm/pos/handlowcy", () => MegaraxUri("megarax://crm/regions")),
  redirect("/crm/pos/salespeople", () => MegaraxUri("megarax://crm/regions")),

  redirect("/crm/pos/visits/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://crm/visits/id/{id}", { id }) : undefined;
  }),
];
